import { Spinner } from "@/ui";
import { useRouter } from "@/utils";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";

function LoginPage() {
    const { loginWithRedirect, user } = useAuth0();
    const router = useRouter();
    const returnTo = router.search.returnTo as string;

    useEffect(() => {
        if (!user) {
            if (returnTo) {
                localStorage.setItem("returnTo", returnTo);
            }
            loginWithRedirect({
                authorizationParams: {
                    redirect_uri: process.env.AUTH0_LOGIN_REDIRECT_URI,
                },
            });
        }
    }, [user, loginWithRedirect]);

    return (
        <>
            <Spinner fullScreen />
            <p className="sr-only">Login Page</p>
        </>
    );
}

export default LoginPage;
